import Vue from 'vue';
import VueToastr from 'vue-toastr';

Vue.use(VueToastr, {
    defaultProgressBar: false,
    defaultPosition: "toast-top-center",
    timeout: 1000
});

export default VueToastr;